import { Slide0MainSlide } from "./Slide0MainSlide";
import { Slide1VisitDates } from "./Slide1VisitDates";
import { Slide2PatientInfo } from "./Slide2PatientInfo";
import { Slide3CaseInfo } from "./Slide3CaseInfo";
import { Slide4Address } from "./Slide4Address";
import { Slide5FinalConfirmation } from "./Slide5FinalConfirmation";
import { Slide6Congratulations } from "./Slide6Congratulations";

export const caseSlides = [Slide1VisitDates, Slide2PatientInfo, Slide3CaseInfo, Slide4Address];

export const slides = [
  Slide0MainSlide,
  ...caseSlides,
  Slide5FinalConfirmation,
  Slide6Congratulations,
];

export interface VisitTravelTimes {
  carTravelTime: string | null;
  busTravelTime: string | null;
}
